import FormWizardTwoContainer from '../../../../Componant/Forms/FormsLayout/FormWizardTwo/FormWizardTwo'

const FormWizardTwo = () => {
  return (
    <div className='page-body'>
      <FormWizardTwoContainer />
    </div>
  )
}

export default FormWizardTwo